@let ticketMarketingData = ticket()?.ticketData;
<aw-section
  [isCollapsible]="true"
  [testIdAffix]="'ticket-owner-data-form' | appendTestId: id()">
  <aw-section-header
    ><div class="flex flex-col items-start">
      <div class="font-semibold">
        {{
          ticketMarketingData?.texts
            ? (ticketMarketingData!.texts
                | filterTexts: RelationType.title
                | language) || ticketName()
            : ticketName()
        }}
      </div>
      @let ticketFormValue = ticketOwnerForm().getRawValue();
      @if (ticketFormValue.firstName && ticketFormValue.lastName) {
        <div>
          {{ ticketFormValue.firstName }} {{ ticketFormValue.lastName }}
          @for (
            companionForm of ticketOwnerForm().controls.companions.controls;
            track companionForm
          ) {
            @let companion = companionForm.getRawValue();
            @if (companion.firstName && companion.lastName) {
              - {{ companion.firstName }} {{ companion.lastName }}
            }
          }
        </div>
      }
    </div>
  </aw-section-header>
  <div [formGroup]="ticketOwnerForm()" class="flex flex-col gap-4">
    @if (isAlternativeTicketOwnerActive()) {
      <aw-checkbox
        formControlName="isForUser"
        [id]="'is-for-user' | appendTestId: id()"
        (valueChange)="setAlternativeControlState($event)"
        [label]="
          textStore.texts()
            | filterTexts
              : ERelationType.ticketIsForMe
              : EEntityType.ticketConfiguration
            | language
        "></aw-checkbox>
    }
    @if (
      auth.isLoggedIn() &&
      !ticketFormValue.isForUser &&
      fellowTravelers().length > 0
    ) {
      <aw-drop-down
        [id]="'fellow-traveler' | appendTestId: id()"
        formControlName="fellowTravelerId"
        [label]="
          textStore.texts()
            | filterTexts
              : ERelationType.loadPassengerData
              : EEntityType.generalArea
            | language
        "
        [options]="fellowTravelerOptions()"
        name="label"
        [showResetIcon]="true"
        valueAttribute="value">
      </aw-drop-down>
    }
    @if (
      fellowTravelerStore.isSalutationEnabled()
    ) {
      <aw-drop-down
        [id]="'ticket-owner-salutation' | appendTestId: id()"
        [label]="
          textStore.texts()
            | filterTexts
              : ERelationType.newCustomerSalutation
              : EEntityType.generalArea
            | language
        "
        formControlName="salutation"
        [options]="salutationOptions() | toTranslatedOption"></aw-drop-down>
    }
    <aw-text-input
      formControlName="firstName"
      [label]="
        textStore.texts()
          | filterTexts
            : ERelationType.newCustomerFirstName
            : EEntityType.generalArea
          | language
      "
      [id]="'ticket-owner-first-name' | appendTestId: id()"></aw-text-input>
    <aw-text-input
      formControlName="lastName"
      [label]="
        textStore.texts()
          | filterTexts
            : ERelationType.newCustomerLastName
            : EEntityType.generalArea
          | language
      "
      [id]="'ticket-owner-last-name' | appendTestId: id()"></aw-text-input>
    @if (
      fellowTravelerStore.isDateOfBirthEnabled()
    ) {
      <aw-date-input
        [id]="'ticket-owner-date-of-birth' | appendTestId: id()"
        [label]="
          textStore.texts()
            | filterTexts
              : ERelationType.personalDataBirthdate
              : EEntityType.generalArea
            | language
        "
        formControlName="dateOfBirth"></aw-date-input>
    }
    @if (ticketOwnerForm().controls.companions.length > 0) {
      <div class="flex flex-col gap-4 pt-6">
        @for (
          companionForm of ticketOwnerForm().controls.companions.controls;
          track companionForm;
          let companionIndex = $index
        ) {
          <aw-direct-ticket-companion-data-form
            [companionForm]="companionForm"
            [companionIndex]="companionIndex"
            [id]="id()"></aw-direct-ticket-companion-data-form>
        }
      </div>
    }
  </div>
</aw-section>
